import { translate } from 'react-i18next';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { RouterAction } from 'connected-react-router';
import { AccountActions, IRootAccountState } from '../models';
import { AccountHome } from './AccountHome';
import { IAccountHomeActions, IAccountHomeMappedProps, IConnectedAccountHomeProps } from './AccountHome.types';
import { auth } from '../../auth';

/**
 * Maps the external (i.e. own) props and the state to the properties of the AccountHome control.
 * @param state The current redux state to map to props
 * @param ownProps The external properties to map to props
 * @returns The mapped properties that along with the actions
 * becomes the props (IAccountHomeProps) for the AccountHome control
 */
export const mapStateToProps = (
  state: IRootAccountState,
  _ownProps: IConnectedAccountHomeProps,
): IAccountHomeMappedProps => {
  const { isSsprConvergenceEnabled, isConvergedUXV2Enabled } = state.account;
  const { profile } = state.user.auth;
  const tenantId = auth.user?.tenantId;
  const upn = auth.user?.username;
  return {
    isSsprConvergenceEnabled,
    isConvergedUXV2Enabled,
    tenantId,
    profile,
    upn,
  };
};

/**
 * Maps the dispatch actions to the props for the AccountHome control.
 * @param dispatch Dispatches actions to the store
 * @returns The mapped actions that along with the mapped properties
 * becomes the props (IAccountHomeProps) for the AccountHome control
 */
export const mapDispatchToProps = (dispatch: Dispatch<IRootAccountState>): IAccountHomeActions => {
  return {
    dispatchRouterAction: (routerAction: RouterAction) => {
      dispatch(routerAction);
    },
    checkOfficeLicenses: () => {
      dispatch({ type: AccountActions.getOfficeLicenses });
    },
  };
};

export const ConnectedAccountHome = connect(mapStateToProps, mapDispatchToProps)(translate('Account')(AccountHome));
